import { IShipment, IFormattedStop, IFullStop, IPickupOrDelivery } from 'types/shipment'
import { stopTime, stopDate } from 'utils/appointmentHelpers'

const getStopMiles = (stop?: IFullStop) => {
  if (stop) {
    return Number(stop.facility.miles).toFixed()
  }

  return undefined
}

/**
 * Utility to format stops for displaying stop details
 *
 * @param shipment Shipment detail object from shipment api call
 * @param mergeStops Optional - merge with existing stops info
 */
export const formatStops = (
  shipment: IShipment,
  mergeStops?: IPickupOrDelivery[]
): IFormattedStop[] => {
  const shipmentStops = shipment.stops
  const lastStopIndex = shipmentStops.length - 1
  const defaultStops = mergeStops || []

  return shipmentStops?.map((stop, index) => {
    const {
      appointment,
      facility,
      info: { specialInstruction },
      type,
    } = stop
    const findMatchingStop = defaultStops.find(
      s => stop.stopSequence === s.stopSequence && stop.type === s.stopType
    )
    const {
      appointmentStatus,
      endAt,
      startAt,
      startAtTime,
      startAtTimezone,
      timezone,
    } = appointment
    const nextStopMiles = Number(stop.facility.miles) || undefined

    // Show distance to next stop, ie: '300 mi to next stop'
    const displayNextStopMiles =
      lastStopIndex === index ? undefined : getStopMiles(shipmentStops[index + 1])
    const formattedRequirements = facility.requirements?.map((req: string) =>
      req.replace('_', ' ').toUpperCase()
    )

    const isConfirmedStatus = !['unconfirmed', 'predicted', undefined].includes(appointmentStatus)

    return {
      ...findMatchingStop,
      ...stop,
      endAtDate: appointment.endAtDate,
      endAtTime: appointment.endAtTime,
      startAtDate: appointment.startAtDate,
      startAtTime: appointment.startAtTime,
      appointmentType: appointment.appointmentType,
      stopType: type,
      nextStopMiles,
      displayNextStopMiles,
      specialInstruction,
      appointmentTime: stopTime(startAt, endAt, timezone, false, startAtTime),
      appointmentDate: stopDate(startAt, timezone),
      appointmentStatus: appointment.appointmentStatus,
      appointment: {
        ...appointment,
        isConfirmedStatus,
      },
      startAtTimezone,
      requirements: formattedRequirements,
    }
  })
}
